//*Libraries imports
import { XIcon } from "lucide-react";

type FilePreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  fileUrl: string | null;
  fileType: string | undefined;
  fileName: string | undefined;
};

export function FilePreviewModal({
  isOpen,
  onClose,
  fileUrl,
  fileType,
  fileName,
}: FilePreviewModalProps) {
  if (!isOpen || !fileUrl) return null;

  const isPdf =
    fileType === "application/pdf" || fileName?.toLowerCase().endsWith(".pdf");

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden animate-in zoom-in-95 duration-200">
        <div className="flex items-center justify-between p-4 border-b border-gray-100">
          <div className="flex flex-col min-w-0">
            <h3 className="font-bold text-clarotexto-201 truncate">
              Visualização do Comprovante
            </h3>
            <p className="text-xs text-gray-500 truncate">{fileName}</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors group"
          >
            <XIcon className="size-5 text-gray-400 group-hover:text-gray-600" />
          </button>
        </div>
        <div className="flex-1 overflow-auto p-4 bg-gray-50 flex items-center justify-center">
          {isPdf ? (
            <iframe
              src={fileUrl}
              className="size-full min-h-[70vh] rounded-lg border border-gray-200 bg-white"
              title="PDF Preview"
            />
          ) : (
            <img
              src={fileUrl}
              alt="Preview"
              className="max-w-full max-h-[70vh] object-contain rounded-lg shadow-sm"
            />
          )}
        </div>
      </div>
    </div>
  );
}
